/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playbar_Speed_ShortInputs */

const en_playbar_speed_short = /** @type {(inputs: Playbar_Speed_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speed`)
};

const es_playbar_speed_short = /** @type {(inputs: Playbar_Speed_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocidad`)
};

/**
* | output |
* | --- |
* | "Speed" |
*
* @param {Playbar_Speed_ShortInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const playbar_speed_short = /** @type {((inputs?: Playbar_Speed_ShortInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playbar_Speed_ShortInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_playbar_speed_short(inputs)
	return en_playbar_speed_short(inputs)
});